<template>
  <b-container>
    <div>
      <div v-if="loading" class="player-spinner offset-sm-6">
        <div class="spinner-border" role="status"></div>
        <div class="loading-text">Loading...</div>
      </div>
      <div id="player"></div>
    </div>
    <div>
      <b-button @click="goBack" variant="primary">Back</b-button>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Player",
  data() {
    return {
      loading: true
    };
  },
  props: {
    stream: Object
  },
  methods: {
    track () {
      this.$ga.page({
        page: '/player',
        title: 'Player (stream ' + this.stream.id + ')',
        location: window.location.href
      })
    },
    goBack() {
      this.$emit("returnToList");
    }
  },
  mounted() {
    this.track()
    axios.defaults.withCredentials = true;
    axios
      .get(this.stream.consume_url, {
        crossDomain: true
      })
      .then(url_response => {
        this.loading = false;
        new Clappr.Player({
          parentId: "#player",
          source: url_response.data["url"],
          plugins: {
            core: [ClapprGaEventsPlugin],
          },
          gaEventsPlugin: {
            trackingId: 'UA-172137407-2',
          },
          autoPlay: true,
          language: "en-GB",
          hlsMinimumDvrSize: 0,
          hlsjsConfig: {
            xhrSetup: xhr => {
              xhr.crossDomain = true;
              xhr.withCredentials = true;
            }
          }
        });
      });
  }
};
</script>
